import React from "react";
import "../../App.scss";
import { updateState } from "../StateHelper";
import AuthorizedPage from "../../component/AuthorizedPage";
import ShipmentApi from "../../api/ShipmentApi";
import { Role } from "../../domain/Role";
import { Modal, Button, Spinner } from "react-bootstrap";
import { DragDropContext, DropResult } from "react-beautiful-dnd";

import OrderItemPool from "../../component/OrderItemPool";
import ShipmentBoard from "../../component/ShipmentBoard";
// import PlanningInfoPanel from "../../component/PlanningInfoPanel";
import ShipmentRouteMap from "../../component/ShipmentRouteMap";

/* ======================
   TYPES & STATE
======================= */

export interface RoutePointDTO {
    lat: number;
    lng: number;
    name: string;
}

export interface ShipmentWaypointsDTO {
    origin: RoutePointDTO;
    destination: RoutePointDTO;
    waypoints: RoutePointDTO[];
}

interface State {
  approvedOrderItems: any[];
  shipments: any[];
  selectedShipmentId: number | null;
  selectedPalletId: number | null;
  loading: boolean;
  showFormationAndProductModal: boolean;
  formationPoints: any[];
  selectedShipmentVehicleId: number | null;
  selectedPlanningId: number | null;
  selectedBoxIndex: number | null;
  selectedLayer: number;
  selectedPalletItems: any[];

  // HARİTA STATE'LERİ
  showMapModal: boolean;
  loadingMap: boolean;
  mapData: ShipmentWaypointsDTO | null;
  driverLinks: string[];
  routeInfo: { distance: string, duration: string } | null;
}

const initialState: State = {
    approvedOrderItems: [],
    shipments: [],
    selectedShipmentId: null,
    selectedPalletId: null,
    loading: false,
    showFormationAndProductModal: false,
    formationPoints: [],
    selectedShipmentVehicleId: null,
    selectedPlanningId: null,
    selectedBoxIndex: null,
    selectedLayer: 1,
    selectedPalletItems: [],

    showMapModal: false,
    loadingMap: false,
    mapData: null,
    driverLinks: [],
    routeInfo: null
};

// Yardımcı fonksiyon
const groupShipmentItemsByOrder = (items: any[]): any[] => {
  if (!items) return [];
  const groups = items.reduce((acc, item) => {
    const key = item.ordersId || item.buyerName;
    if (!acc[key]) {
      acc[key] = {
        ordersId: item.ordersId || 999,
        buyerName: item.buyerName,
        items: []
      };
    }
    acc[key].items.push(item);
    return acc;
  }, {} as any);
  return Object.values(groups);
};

class ShipmentOrderManagement extends React.Component<{}, State> {
  state = initialState;

  componentDidMount() {
    this.loadPlanningData();
  }

  async loadPlanningData() {
    try {
      const orderItemResponse = await ShipmentApi.listOrderGroupedItemsForPlanning();
      if (orderItemResponse?.success) {
        updateState(this, "approvedOrderItems", orderItemResponse.data || []);
      }

      const shipmentResponse = await ShipmentApi.listOrderShipmentsForPlanning();
      if (shipmentResponse?.success) {
        const rawShipments = shipmentResponse.data || [];
        const formattedShipments = rawShipments.map((s: any) => {
            const orders = (s.orders && s.orders.length > 0)
                ? s.orders
                : groupShipmentItemsByOrder(s.items || []);
            return { ...s, orders: orders };
        });
        updateState(this, "shipments", formattedShipments);
      }
    } catch (e) {
      console.error("Planlama verileri alınamadı", e);
    }
  }

  onDragEnd = async (result: DropResult) => {
     const { source, destination, draggableId } = result;
     if (!destination) return;
     const orderIdFromDraggable = Number(draggableId.replace("order-", ""));
     if (isNaN(orderIdFromDraggable)) return;

     if (source.droppableId === "orderItemPool" && destination.droppableId.startsWith("shipment-")) {
        const shipmentId = Number(destination.droppableId.replace("shipment-", ""));
        await ShipmentApi.assignOrderGroupToShipment({ shipmentId, ordersId: orderIdFromDraggable });
        await this.loadPlanningData();
     } else if (source.droppableId.startsWith("shipment-") && destination.droppableId === "orderItemPool") {
        const shipmentId = Number(source.droppableId.replace("shipment-", ""));
        await ShipmentApi.deassignOrderGroupFromShipment(shipmentId, orderIdFromDraggable);
        await this.loadPlanningData();
     }
  };

  handleDetailClick = async (shipmentId: number) => {
      // Detay modal işlemleri...
  };

  handleCompleteClick = async (shipmentId: number) => {
      if (window.confirm("Bu sevkiyat planı onaylanacak ve araç yükleme aşamasına geçecek. Devam edilsin mi?")) {
        try {
          this.setState({ loading: true });
          const response = await ShipmentApi.confirmShipmentPlan(shipmentId);
          if (response?.success) {
            await this.loadPlanningData();
            alert("Plan başarıyla onaylandı!");
          } else {
            alert("Hata: " + (response?.error || "İşlem başarısız oldu."));
          }
        } catch (error) {
          console.error("Onaylama hatası:", error);
        } finally {
          this.setState({ loading: false });
        }
      }
  };

  handleShowMapClick = async (shipment: any) => {
    const shipmentId = shipment.id;

    this.setState({
        showMapModal: true,
        loadingMap: true,
        mapData: null,
        driverLinks: [],
        routeInfo: null
    });

    try {
        const response = await ShipmentApi.getShipmentWaypoints(shipmentId);

        if (response?.success && response.data) {
            this.setState({ mapData: response.data as ShipmentWaypointsDTO });
        } else {
            alert("Rota verisi alınamadı: " + (response?.error || "Bilinmeyen hata"));
            this.setState({ showMapModal: false });
        }
    } catch (error) {
        console.error("Harita verisi çekilemedi:", error);
        alert("Bir hata oluştu.");
        this.setState({ showMapModal: false });
    } finally {
        this.setState({ loadingMap: false });
    }
  }

  handleRouteCalculated = (links: string[], distance: string, duration: string) => {
      if (this.state.driverLinks.length === 0) {
          this.setState({
              driverLinks: links,
              routeInfo: { distance, duration }
          });
      }
  }

  renderFormationModal = () => { return null; };

  render() {
      const { approvedOrderItems, shipments, selectedPalletId } = this.state;

    return (
      <AuthorizedPage role={Role.SHIPPING_STAFF}>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="container-fluid py-4">

            {/* 🔥 EKLENEN BAŞLIK ALANI */}
            <div className="mb-4">
               <h3 className="fw-bold text-dark">Sipariş-Sevkiyat Yönetimi</h3>
            </div>

            <div className="row">
              <OrderItemPool groups={approvedOrderItems} />

              <ShipmentBoard
                shipments={shipments}
                onDetailClick={this.handleDetailClick}
                onCompleteClick={this.handleCompleteClick}
                onShowMap={this.handleShowMapClick}
              />

              {/* <PlanningInfoPanel selectedPalletId={selectedPalletId} /> */}
            </div>
          </div>
        </DragDropContext>

        {this.renderFormationModal()}

        {/* HARİTA MODALI */}
        <Modal
            show={this.state.showMapModal}
            onHide={() => this.setState({ showMapModal: false })}
            size="xl"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Sevkiyat Rotası
                    {this.state.mapData ? ` - ${this.state.routeInfo?.distance || ''}` : ''}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-0 position-relative">
                {this.state.loadingMap && (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                        <Spinner animation="border" variant="primary" />
                        <span className="ms-2">Rota verileri alınıyor...</span>
                    </div>
                )}

                {!this.state.loadingMap && this.state.mapData && (
                    <ShipmentRouteMap
                        origin={this.state.mapData.origin}
                        destination={this.state.mapData.destination}
                        waypoints={this.state.mapData.waypoints}
                        onRouteCalculated={this.handleRouteCalculated}
                    />
                )}
            </Modal.Body>

            <Modal.Footer className="d-block">
                {this.state.routeInfo && (
                    <div className="alert alert-info text-center py-2 mb-3">
                        <strong>Toplam Mesafe:</strong> {this.state.routeInfo.distance} •
                        <strong> Tahmini Süre:</strong> {this.state.routeInfo.duration}
                    </div>
                )}

                <div className="d-flex flex-column gap-2">
                    {this.state.driverLinks.map((link, idx) => (
                        <div key={idx} className="d-flex gap-2">
                            <Button
                                variant={idx === 0 ? "primary" : "secondary"}
                                className="flex-grow-1 text-start"
                                onClick={() => window.open(link, '_blank')}
                            >
                                🗺️ {this.state.driverLinks.length > 1 ? `${idx + 1}. Bölüm Rotası` : "Navigasyonu Başlat"}
                            </Button>

                            <Button
                                variant="success"
                                onClick={() => {
                                    const msg = `Sefer Görevi ${idx + 1}. Kısım Linki: ${link}`;
                                    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
                                }}
                            >
                                <i className="bi bi-whatsapp"></i> WhatsApp
                            </Button>
                        </div>
                    ))}
                </div>

                <div className="text-end mt-2 border-top pt-2">
                    <Button variant="secondary" onClick={() => this.setState({ showMapModal: false })}>Kapat</Button>
                </div>
            </Modal.Footer>
        </Modal>
      </AuthorizedPage>
    );
  }
}

export default ShipmentOrderManagement;